const getRadialGradient = (gradient) => {
  if (!gradient) {
    return "transparent";
  }
  const { top, left, position, color } = gradient;
  const positions = Object.entries(position).map(([key, value]) => `${color[key]} ${value}%`).join(", ");
  return `radial-gradient(circle at ${left}% ${top}%, ${positions})`;
};
const SPLIT_REGEX = /\s+/u;
const abbreviate = (text, maxLength) => {
  if (!text)
    return "";
  const words = text.trim().split(SPLIT_REGEX);
  if (words.length === 1) {
    return text.slice(0, maxLength).toUpperCase();
  }
  const initials = words.map((word) => word.charAt(0)).join("");
  return initials.slice(0, maxLength).toUpperCase();
};
export {
  abbreviate,
  getRadialGradient
};
